export default __webpack_public_path__ + "static/media/February2019.baef77ec.png";